import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import Fields, { Field } from "components/ui/Fields";
import createFormActions from "modules/form/actions";
import ModalService from "services/modal";
import { connectField, createForm } from "modules/form";
import Button from "components/ui/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-solid-svg-icons";
import Modal from "components/ui/Modal";
import { Slider } from "antd";

import retro from "assets/sounds/night-lights.mp3";
import chill from "assets/sounds/spectrum.mp3";
import engaging from "assets/sounds/oceanarium.mp3";
import relaxing from "assets/sounds/touch.mp3";
import Sound from "modules/gameSettings/Sound";

import click from "assets/sounds/click.mp3";
import { useGameSettings } from "./hook";
import { isSSR } from "utils/dom";

//

export const settingFormActions = createFormActions({
  init() {
    return Promise.resolve({
      music: false,
      sounds: false,
      volume: 50,
      style: retro,
    });
  },
});

const SliderField = connectField(Field(Slider));
const MUSIC_STYLES = [
  {
    label: "Chill",
    value: chill,
  },
  {
    label: "Retro",
    value: retro,
  },
  {
    label: "Engaging",
    value: engaging,
  },
  {
    label: "Relaxing",
    value: relaxing,
  },
];

export const settingsModal = new ModalService();

const SettingsButton = styled(Button)`
  margin-bottom: 10px;
  .svg-inline--fa {
    margin-left: 10px;
  }
`;

function GameSettingsForm() {
  return (
    <>
      <Fields.Switch name="music" label="Music" />
      <Fields.Switch name="sounds" label="Sounds" />
      <SliderField name="volume" label="Volume" />
      <Fields.RadioGroup
        label="Music preference"
        name="style"
        options={MUSIC_STYLES}
      />
    </>
  );
}

const SettingsFormModule = createForm({
  Component: GameSettingsForm,
  actions: settingFormActions,
});

function openModal() {
  return function thunk(dispatch) {
    settingsModal.open().then(() => {
      dispatch({
        type: "UPDATE_SETTINGS",
      });
    });
  };
}

const GameSettingsUI = connect(
  (state) => ({ gameStarted: state.game.startTimer }),
  { openModal },
)(({ openModal, gameStarted }) => {
  const gameSettings = useGameSettings();

  return (
    <>
      <SettingsButton onClick={openModal} data-step="settings">
        Settings <FontAwesomeIcon icon={faCog} />
      </SettingsButton>
      {!isSSR() ? (
        <Modal title="Game settings" service={settingsModal}>
          <SettingsFormModule module="gameSettings" preventInitOnMount />
        </Modal>
      ) : null}
      {gameSettings.style ? (
        <Sound.Music url={gameSettings.style} play={gameStarted} />
      ) : null}
      <Sound.GlobalClick url={click} />
    </>
  );
});

export default GameSettingsUI;
